export default __webpack_public_path__ + "static/media/bg-dashboard.31a33f12.png";